/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * This file export types that may be useful for consuming code
 *
 * Note: External code should only rely on what is exported in the main
 * index.ts (if you need more types externally, then reexport form that file).
 */

import {
  TypedAsyncCommandApi, JsonRpc, ErrorCategory,
} from '@/lib/web-api'

import { ClientFlowApi } from './ClientFlowApi'

type extractError<Type> = Type extends TypedAsyncCommandApi<any, any, infer E> ? E : never
type ErrorTypes = extractError<ClientFlowApi>

// This is the error _classes_ exported. This I need to specify manually, since
// I don't know how to extract it from ClientFlowApi. If anything changes
// in the underlying implementation, you probably have to update it here.
const { Errors } = JsonRpc

export { ErrorTypes, ErrorCategory, Errors }
